import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import {
  Table,
  Tbody,
  Tr,
  Td,
  Th,
  TableContainer,
  Spinner,
  Box,
  Text,
} from "@chakra-ui/react";
import { BASE_URL } from "../../Globalapi/Globalapi";

const Print_pdf_Timetable_student = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const [timetableData, setTimetableData] = useState([]);
  const [error, setError] = useState(null); // For error state
  const schoolName = sessionStorage.getItem("school_name");
  const schoolEmail = sessionStorage.getItem("school_email");
  const schoolAddress = sessionStorage.getItem("school_address");
  const schoolImage = sessionStorage.getItem("school_image_url");
  const printRef = useRef();

  useImperativeHandle(ref, () => ({
    handlePrint,
  }));

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);

    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(`<div>${content}</div>`);
    iframeDoc.close();

    const images = iframeDoc.getElementsByTagName("img");
    const loadPromises = Array.from(images).map(
      (img) =>
        new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        })
    );

    Promise.all(loadPromises).then(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    });
  };

  useEffect(() => {
    // Retrieve selected class and division from localStorage
    const selectedClass = localStorage.getItem("class_id");
    const selectedDivision = localStorage.getItem("division_id");

    if (selectedClass && selectedDivision) {
      setLoading(true);

      fetch(`${BASE_URL}/admin/timetable/list_all_time_table.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          class_id: selectedClass,
          division_id: selectedDivision,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (Array.isArray(data.data)) {
            setTimetableData(data.data);
            setError(null);
          } else {
            setError("Unexpected response format.");
          }
        })
        .catch((error) => {
          setError("Error fetching timetable");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  // Transform data for the timetable
  const transformedData = timetableData.reduce((acc, item) => {
    const { day, subject, class: className, division } = item;
    const dayIndex = acc.findIndex((row) => row.day === day);

    if (dayIndex === -1) {
      acc.push({
        day,
        subjects: [{ subject, className: `${className} ${division}` }],
      });
    } else {
      acc[dayIndex].subjects.push({
        subject,
        className: `${className} ${division}`,
      });
    }

    return acc;
  }, []);

  // Determine the maximum number of subjects for column headers
  const maxSubjectsCount = Math.max(
    ...transformedData.map((dayData) => dayData.subjects.length),
    0
  );

  return (
    <div
      ref={printRef}
      style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "40px",
          borderBottom: "1px solid #e5e5e5",
          paddingBottom: "20px",
          gap: "24px",
        }}
      >
        <img
          src={schoolImage ? `${schoolImage}` : ""}
          alt={`school Logo`}
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain",
            backgroundColor: "#fff",
            padding: "10px",
          }}
        />

        <div>
          <h1
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: "#1a1a1a",
              fontFamily: "'Times New Roman', serif",
              letterSpacing: "0.5px",
            }}
          >
            {schoolName}
          </h1>
          <h2
            style={{
              margin: "6px 0 0",
              fontSize: "18px",
              fontWeight: "500",
              color: "#666",
              fontFamily: "'Times New Roman', serif",
            }}
          >
            {schoolAddress}
          </h2>
          <p
            style={{
              fontSize: "14px",
              color: "#6C757D",
              margin: "6px 0 0",
              fontFamily: "Arial, sans-serif",
            }}
          >
            {schoolEmail}
          </p>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <h3>Timetable for Students</h3>
        {loading ? (
          <Box textAlign="center">
            <Spinner size="xl" />
          </Box>
        ) : error ? (
          <Box textAlign="center" color="red.500">
            {error}
          </Box>
        ) : (
          <TableContainer>
            <Table
              sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}
              style={{
                border: "1px solid #d4c2c2",
                borderCollapse: "collapse",
                width: "100%",
              }}
            >
              <Tbody>
                {transformedData.map((dayData, index) => (
                  <Tr key={index}>
                    <Td style={{ border: "1px solid #d4c2c2", padding: "8px" }}>
                      {dayData.day}
                    </Td>
                    {[...Array(maxSubjectsCount)].map((_, idx) => (
                      <Td
                        key={idx}
                        style={{ border: "1px solid #d4c2c2", padding: "8px" }}
                      >
                        {dayData.subjects[idx] ? (
                          <div>
                            {dayData.subjects[idx].subject} -{" "}
                            {dayData.subjects[idx].className}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </Td>
                    ))}
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </div>
    </div>
  );
});

export default Print_pdf_Timetable_student;
